import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\CreateCompanyController::__invoke
* @see app/Http/Controllers/Company/CreateCompanyController.php
* @route '/api/company'
*/
const CreateCompanyController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCompanyController.url(options),
    method: 'post',
})

CreateCompanyController.definition = {
    methods: ["post"],
    url: '/api/company',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Company\CreateCompanyController::__invoke
* @see app/Http/Controllers/Company/CreateCompanyController.php
* @route '/api/company'
*/
CreateCompanyController.url = (options?: RouteQueryOptions) => {
    return CreateCompanyController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\CreateCompanyController::__invoke
* @see app/Http/Controllers/Company/CreateCompanyController.php
* @route '/api/company'
*/
CreateCompanyController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCompanyController.url(options),
    method: 'post',
})

export default CreateCompanyController